export default {
    title: "Izaberi interesovanja",
    back: 'Nazad',
    button: "Sačuvaj",
    skip: 'Preskoči'
};
